import { z } from 'zod';

import { t } from '@/shared/i18n';

export const spaceSchema = z.object({
  name: z.string().trim().min(1, t.profile.nameRequired).max(100),
  slug: z
    .string()
    .min(2)
    .max(40)
    .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/, t.workspace.slugInvalid),
  description: z.string().max(2000),
  color: z.string().regex(/^[0-9a-f]{6}$/),
});

export type SpaceValues = z.infer<typeof spaceSchema>;
